import { render, staticRenderFns } from "./NotificationPanel.vue?vue&type=template&id=2319af62&scoped=true"
import script from "./NotificationPanel.vue?vue&type=script&lang=js"
export * from "./NotificationPanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationPanel.less?vue&type=style&index=0&id=2319af62&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2319af62",
  null
  
)

export default component.exports